import { c as _c } from "react/compiler-runtime";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
interface NftPickerActionsProps {
  canAddTokens: boolean;
  allowAll: boolean;
  selectedContract: boolean;
  selectAllLabel: string;
  onSelectAll: () => void;
  onAdd: () => void;
}
export function NftPickerActions(t0) {
  const $ = _c(11);
  const {
    canAddTokens,
    allowAll,
    selectedContract,
    selectAllLabel,
    onSelectAll,
    onAdd
  } = t0;
  const t1 = !canAddTokens;
  let t2;
  if ($[0] !== onAdd || $[1] !== t1) {
    t2 = <PrimaryButton onClicked={onAdd} loading={false} disabled={t1}>Add</PrimaryButton>;
    $[0] = onAdd;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== allowAll || $[4] !== onSelectAll || $[5] !== selectAllLabel || $[6] !== selectedContract) {
    t3 = allowAll && <SecondaryButton onClicked={onSelectAll} disabled={!selectedContract} className="tw-w-full sm:tw-w-auto">{selectAllLabel}</SecondaryButton>;
    $[3] = allowAll;
    $[4] = onSelectAll;
    $[5] = selectAllLabel;
    $[6] = selectedContract;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="tw-flex tw-flex-col tw-gap-2 sm:tw-flex-row sm:tw-items-center">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}